module.exports = __webpack_public_path__ + "img/banner-2-mobile.e27eafd.webp";